'use strict';

var React = require('react');

var SvgMarkFulfilledMinor = function SvgMarkFulfilledMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18 16.5a1.5 1.5 0 0 1-1.5 1.5h-13a1.5 1.5 0 0 1-1.5-1.5v-7.5h2v4h2.382c.379 0 .725.214.894.553l.724 1.447h4l.724-1.447a.998.998 0 0 1 .894-.553h2.382v-4h2v7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.293 8.707-3-3a.999.999 0 1 1 1.414-1.414l2.293 2.293 4.293-4.293a.999.999 0 1 1 1.414 1.414l-5 5a.997.997 0 0 1-1.414 0z"
  }));
};

exports.SvgMarkFulfilledMinor = SvgMarkFulfilledMinor;
